// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TableSvg from '@rsuite/icon-font/lib/charts/Table';
var Table = createSvgIcon({
  as: TableSvg,
  ariaLabel: 'table',
  category: 'charts',
  displayName: 'Table'
});
export default Table;